import { Controller } from '@hotwired/stimulus'

// Delivery hours on the Delivery settings page: each day can take a second opening. Removing
// it clears both times, which the page's one Save then stores as no extra hours.
export default class extends Controller {
  static targets = ['extra', 'add']

  addHours(event) {
    const day = this.#day(event)
    const extra = this.#within(this.extraTargets, day)
    extra.hidden = false
    this.#within(this.addTargets, day).hidden = true
    extra.querySelector('select').focus()
  }

  removeHours(event) {
    const day = this.#day(event)
    const extra = this.#within(this.extraTargets, day)
    extra.querySelectorAll('select').forEach((select) => { select.value = '' })
    extra.hidden = true
    const add = this.#within(this.addTargets, day)
    add.hidden = false
    add.focus()
  }

  #day(event) {
    return event.currentTarget.closest('.dz-day')
  }

  #within(targets, day) {
    return targets.find((target) => day.contains(target))
  }
}
